import type {
  AssignmentOption,
  QueryAssignment,
  ResourceResponse,
} from '@travel-crm/types';

import { apiRequest } from './api-client';

export const assignmentQueryKeys = {
  root: ['query-assignments'] as const,
  history: (queryId: string) => ['query-assignments', queryId] as const,
  options: (department: 'RESERVATION' | 'SALES') =>
    ['query-assignment-options', department] as const,
};

export async function fetchAssignmentOptions(
  department: 'RESERVATION' | 'SALES',
): Promise<AssignmentOption[]> {
  return (
    await apiRequest<ResourceResponse<AssignmentOption[]>>(
      `/api/v1/queries/assignment-options?department=${department}`,
    )
  ).data;
}

export async function fetchQueryAssignments(
  queryId: string,
): Promise<QueryAssignment[]> {
  return (
    await apiRequest<ResourceResponse<QueryAssignment[]>>(
      `/api/v1/queries/${queryId}/assignments`,
    )
  ).data;
}

export async function setSalesOwner(input: {
  queryId: string;
  expectedVersion: number;
  salesExecutiveId: string;
  reason?: string | null;
}): Promise<QueryAssignment> {
  return (
    await apiRequest<ResourceResponse<QueryAssignment>>(
      `/api/v1/queries/${input.queryId}/sales-owner`,
      {
        method: 'POST',
        body: JSON.stringify({
          expectedVersion: input.expectedVersion,
          salesExecutiveId: input.salesExecutiveId,
          ...(input.reason === undefined ? {} : { reason: input.reason }),
        }),
      },
    )
  ).data;
}

export async function createQueryAssignment(input: {
  queryId: string;
  expectedVersion: number;
  department: 'RESERVATION' | 'SALES';
  assignmentType: 'PRIMARY' | 'ADDITIONAL';
  userId?: string | null | undefined;
  teamId?: string | null | undefined;
  reason?: string | null | undefined;
}): Promise<QueryAssignment> {
  return (
    await apiRequest<ResourceResponse<QueryAssignment>>(
      `/api/v1/queries/${input.queryId}/assignments`,
      {
        method: 'POST',
        body: JSON.stringify({
          expectedVersion: input.expectedVersion,
          department: input.department,
          assignmentType: input.assignmentType,
          ...(input.userId !== undefined ? { userId: input.userId } : {}),
          ...(input.teamId !== undefined ? { teamId: input.teamId } : {}),
          ...(input.reason !== undefined ? { reason: input.reason } : {}),
        }),
      },
    )
  ).data;
}

export async function endQueryAssignment(input: {
  queryId: string;
  assignmentId: string;
  expectedVersion: number;
  reason: string;
}): Promise<QueryAssignment> {
  return (
    await apiRequest<ResourceResponse<QueryAssignment>>(
      `/api/v1/queries/${input.queryId}/assignments/${input.assignmentId}/end`,
      {
        method: 'POST',
        body: JSON.stringify({
          expectedVersion: input.expectedVersion,
          reason: input.reason,
        }),
      },
    )
  ).data;
}
